module.exports = __webpack_public_path__ + "img/fm-f-Path 55 Copy@3x.1c60a18e.png";